import { getFontSizes } from './helper';

export const aixTheme = {
  colors: {
    base: {
      primary: 'var(--color-primary)',
      secondary: '',
    },
    text: {
      primary: '#000',
      secondary: '',
    },
    button: {
      primary: {
        bg: '#FF6423',
        text: '#FFFFFF',
        border: '#FF6423',
        color: '#FF6423',
        bg2: '#F9E4DF',
      },
      updateBtn: {
        bg: '#FF6423',
      },
      secondary: {
        bg: '#ffffff',
        text: '#26329F',
      },
      topNav: {
        bg: '#FF6423',
        text: 'var(--color-btn-primary-text)',
      },
    },
    overlays: {
      topNavForm: '#ffffff',
    },
    label: {
      primary: '#6D6E71',
      secondary: '',
    },
    link: {
      primary: 'var(--color-link-primary)',
      secondary: 'var(--color-link-secondary)',
    },
    slider: {
      track: 'var(--color-link-primary)',
    },
    topNav: '#6D6E71',
    bodyBG: '#f2f2f2',
    topnavInput: '#000000',
    topnavInputPlaceholder: '#000000',
    topnavBtnShimmer: '#FF6423',
    agentInputBG: 'rgba(0, 0, 0, 0.1)',
    agentSearchIconBG: '#FFFFFF',
    exploreLinksColor: '#FFFFFF',
  },
  font: {
    size: {
      main: getFontSizes(),
      pageHeader: '40px',
      heading: '32px',
      subHeading: '16px',
      button: getFontSizes('12px', '16px', '18px', '20px'),
    },
    weight: '900',
  },
  images: {
    logo: '',
    mainBg: '',
    favicon:
      'https://hldak.mmtcdn.com/prod-s3-hld-hpcmsadmin/holidays/images/phonixImages/AIX-FeviconIcon.jpg',
  },
  radius: {
    button: {
      topNav: '34px',
      primary: '34px',
      secondary: '6px',
    },
  },
  topNav: {
    inputContainerBorder: '1px solid rgba(54,54,54, 0.1)',
  },
  detailsPage: {
    mainNav: {
      fontSize: '14px',
      fontWeight: '900',
    },
    itineraryNav: {
      bgColor: '#F9E4DF',
      marginBottom: '0',
      tab: {
        color: '#4a4a4a',
        bgColor: 'transparent',
        active: {
          bgColor: '#FFFFFF',
          color: '#FF6423',
          border: '#FF6423',
        },
      },
    },
    dayplan: {
      bgColor: '#ffffff',
      title: {
        bg: '#FF6423',
        bg2: '#FF6423',
        color: 'var(--color-btn-primary-text)',
      },
      flightUpgradeRow: {
        bg: '#FF6423',
        margin: '10px 0 0',
        borderRadius: '0',
      },
    },
    rightContainer: {
      topHeader: {
        bg: '#ffffff',
      },
    },
  },
  thankyouPage: {
    topHeaderColor: '#FFF',
    bg: ' linear-gradient(238.38deg, #4AFFCD -141.22%, #FF6423 87.22%)',
  },
  reviewPage: {
    bgColor: '#6D6E71',
    navColor: '#9b9b9b',
  },
};
